import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

const Button = ({
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  iconOnly = false,
  disabled = false,
  pressed,
  children,
  type = 'button',
  ...theRestOfTheProps
}) => {
  const BUTTON_SIZES = ['minimal', 'sm','md','lg','xl','xxl','xxxl','inherit'];
  const resolvedSize = BUTTON_SIZES.includes(size) ? size : 'md';
  const className = clsx(
    styles.Button,
    styles[`Button--${variant}`],
    {
      [styles['Button--iconOnly']]: iconOnly,
      [styles['Button--pressed']]: pressed,
    }
  );

  return (
    <button
      type={type}
      className={className}
      data-size={resolvedSize}
      disabled={disabled}
      aria-disabled={disabled}
      aria-pressed={pressed !== undefined ? pressed : undefined}
      {...theRestOfTheProps}
    >
      {icon && iconPosition === 'left' && (
        <span className={styles.Button__icon} aria-hidden="true">
          {icon}
        </span>
      )}

      {!iconOnly && (
        <span className={styles.Button__label}>
          {children}
        </span>
      )}

      {icon && iconPosition === 'right' && (
        <span className={styles.Button__icon} aria-hidden="true">
          {icon}
        </span>
      )}
    </button>
  );
};

export default Button;
